// src/features/auth/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchUserInfoAPI, updateUserInfoAPI } from "./authAPI";
import { authService } from "../../services/authService";

const initialState = {
  isLoggedIn: false,
  user: {
    id: 0,
    session: "",
    max_student_capacity: 0,
    plan: "",
  },
};

export const fetchUserInfo = createAsyncThunk(
  "auth/fetchUserInfo",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchUserInfoAPI();
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateUserInfo = createAsyncThunk(
  "auth/updateUserInfo",
  async (data, { rejectWithValue }) => {
    try {
      const response = await updateUserInfoAPI(data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess(state) {
      state.isLoggedIn = true;
    },
    loginFailure(state) {
      state.isLoggedIn = false;
    },
    logOut(state) {
      state.isLoggedIn = false;
      authService.removeTokens();
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUserInfo.fulfilled, (state, action) => {
      state.user = action.payload;
    });
    builder.addCase(fetchUserInfo.rejected, (state) => {
      state.isLoggedIn = false;
    });
    builder.addCase(updateUserInfo.fulfilled, (state, action) => {
      state.user = action.payload;
    });
    builder.addCase(updateUserInfo.rejected, (state) => {
      state.isLoggedIn = false;
    });
  },
});

export const { loginSuccess, loginFailure, logOut } = authSlice.actions;
export default authSlice.reducer;
